import "./bootstrap";
import "../css/app.css";
import "./config";
import { createPinia } from 'pinia'


import "animate.css";
import WOW from "wow.js";

import VLazyImage from "v-lazy-image";
import "@fortawesome/fontawesome-free/css/all.min.css";

import LoadingOverlay from "@/Components/LoadingOverlay.vue";

import { createApp, h } from "vue";
import i18n from "./i18n";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import DataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { MotionPlugin } from "@vueuse/motion";
import Sweetalert from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const options = {
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
};
import Vue3Autocounter from "vue3-autocounter";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue.m";

const appName = import.meta.env.VITE_APP_NAME || "Laravel";
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        JSON.parse(el.dataset.page)
        const pinia = createPinia()
        const app = createApp({ render: () => h(App, props) });
        app.use(plugin);
        app.use(i18n);
        app.use(Toast, { timeout: 2000 });
        app.use(Sweetalert);
        window.Swal = app.config.globalProperties.$swal;
        app.component("LoadingOverlay", LoadingOverlay);
        app.component("VLazyImage", VLazyImage);
        app.component("DataTable", DataTable);
        app.component("Multiselect", Multiselect);
        app.component("QuillEditor", QuillEditor);
        app.use(ElementPlus);
        app.use(MotionPlugin);
        app.use(pinia)
        app.component("vue3-autocounter", Vue3Autocounter);
        app.use(ZiggyVue, Ziggy);
        app.mount(el);
    },
    progress: {
        color: "#1cbed1",
        showSpinner: false,
    },
});
// Initialize WOW.js globally
document.addEventListener("DOMContentLoaded", () => {
    const wow = new WOW();
    wow.init();
});
